import { garHouseInfoFieldsInSS, houseAbbriviations } from '../FiasOverrider.constants';
const getName = (parts = []) => {
    if (!parts) {
        return '';
    }
    return parts
        .map(({ type, number }) => {
        const abbreviation = type ? houseAbbriviations[type] : '';
        return `${abbreviation || ''} ${number}`.trim();
    })
        .join(' ');
};
export const convertHouseToGarHouse = (house) => {
    if (!house) {
        return;
    }
    const parts = house?.parts || [];
    const data = garHouseInfoFieldsInSS.reduce((acc, cur, i) => {
        const part = parts[i];
        const index = cur.possibleTypeValues.findIndex((item) => item.toLowerCase() === part?.type?.toLowerCase());
        if (index === -1) {
            return acc;
        }
        return {
            ...acc,
            [cur.numberFieldName]: part.number,
            [cur.typeFieldName]: cur.possibleTypeValues[index],
        };
    }, { id: '', fiasId: house.fiasId || '' });
    return {
        name: house.name || getName(parts) || '',
        text: '',
        data,
    };
};
